import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID: ClientId = client(
	'rovo-experience-tracking-sender',
);
